import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { dlGtpDataVolumeChartConfig } from '../chartConfigs';

/**
 * Props for the DlGtpDataVolumeEcharts component
 */
interface DlGtpDataVolumeEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Downlink GTP Data Volume Chart (LTE Site Level)
 * 
 * Displays aggregated downlink GPRS Tunneling Protocol (GTP) data volume metrics across all cells in an LTE site.
 * Shows the total volume of downlink data transmitted through the site over time.
 * 
 * This component is a thin wrapper around the SiteCharts template component,
 * configured with site-level DL data volume metrics from chartConfigs.ts
 * 
 * @component
 * @example
 * ```tsx
 * <DlGtpDataVolumeEcharts
 *   onFullscreenToggle={() => setFullscreen(!fullscreen)}
 *   isFullscreen={false}
 * />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (dlGtpDataVolumeChartConfig)
 * @see {@link ../../../components/SiteCharts.tsx} - Template component
 * @see API: /api/lte/dl-gtp-data-volume?site_name={siteName}
 */

const DlGtpDataVolumeEcharts: React.FC<DlGtpDataVolumeEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={dlGtpDataVolumeChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default DlGtpDataVolumeEcharts;
